import { create } from "zustand";
import { persist } from "zustand/middleware";

const useThemeStore = create(
  persist(
    (set) => ({
      isDark: window.matchMedia("(prefers-color-scheme: dark)").matches,
      toggle: () =>
        set((s) => {
          const next = !s.isDark;
          document.documentElement.classList.toggle("dark", next);
          return { isDark: next };
        }),
      init: () =>
        set((s) => {
          document.documentElement.classList.toggle("dark", s.isDark);
          return {};
        }),
    }),
    { name: "joborigo-theme" }
  )
);

export default useThemeStore;